import React, { ReactElement, useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import {
  Breadcrumbs, getTitle, homeBreadcrumb, setTitle,
} from 'slovlex-idsk-react-components';
import { Loader } from 'idsk-react-components';
import MpkCancel from '../../../module/PracovnyKrok/MpkCancel';
import useLegislativnyMaterialDetail
  from '../../../module/LegislativnyMaterial/LegislativnyMaterialDetail/hooks/useLegislativnyMaterialDetail';
import routes from '../../../routing/routes';
import GlobalErrors from '../../../module/GlobalErrors';
import PageHeadingWithBackButton from '../../../module/PageHeadingWithBackButton';
import Layout from '../../Layout';
import SecuredPage from '../../../module/SecuredPage';
import PracovnyKrokEnum from '../../../model/pracovnyKrok/PracovnyKrokEnum';
import SuccessMessages from '../../../module/SuccessMessages';

const MpkCancelPage = (): ReactElement => {
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  const {
    materialDetail,
    materialStatus,
  } = useLegislativnyMaterialDetail(PracovnyKrokEnum.ZRUSIT_MPK);

  const currentLocation = useLocation();

  function isPredbeznaInformacia(): boolean {
    return type === 'PI';
  }

  useEffect(() => {
    if (!materialStatus.loading) {
      setTitle(getTitle());
    }
  }, [materialStatus.loading]);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          heading: isPredbeznaInformacia() ? 'Predbežné informácie' : 'Legislatívne procesy',
          to: isPredbeznaInformacia() ? routes.procesy.predbeznaInformacia.list : routes.procesy.list,
        },
        {
          heading: `${type}/${year}/${index}`,
          to: routes.procesy.detail.withParams(type, year, index),
        },
        {
          heading: 'Zrušenie Pripomienkového konania',
          to: currentLocation.pathname,
        },
      ]}
      />
      <GlobalErrors />
      <Loader loading={materialStatus.loading}>
        <SecuredPage
          additionalCheck={materialDetail?.hasPracovnyKrokInZasobnikPrace}
          hasOpravneniePracovneKroky={materialDetail?.hasOpravneniePracovneKroky}
          requestStatus={materialStatus.responseCode}
        >
          <>
            <SuccessMessages />
            {materialDetail && (
              <>
                <PageHeadingWithBackButton
                  heading="Zrušenie Pripomienkového konania"
                  headingCaption={`Legislatívny proces ${materialDetail.cisloLegislativnehoMaterialu}`}
                />
                <MpkCancel materialDetail={materialDetail} />
              </>
            )}
          </>
        </SecuredPage>
      </Loader>
    </Layout>
  );
};

export default MpkCancelPage;
